document.addEventListener('DOMContentLoaded', function() {
  const WEBSITE_NAME = 'Hape';
  const KEYWORDS = [
    'educational toys', 'wooden toys', 'eco-friendly toys', 
    'STEM learning kits', 'role-play sets', 'outdoor games',
    'baby toddler toys', 'sustainable toys', 'creative toys',
    'developmental toys', 'musical instruments', 'train sets',
    'arts and crafts', 'safe toys', 'non-toxic toys'
  ];

  // Random keyword selector
  function getRandomKeyword() {
    return KEYWORDS[Math.floor(Math.random() * KEYWORDS.length)];
  }

  // 1. Enhanced image alt text handling
  document.querySelectorAll('img:not([alt])').forEach(img => {
    const keyword = getRandomKeyword();
    img.alt = `${WEBSITE_NAME} baby toys ${keyword.replace('toys', '').trim()}`;
  });

  // 2. Comprehensive ARIA labeling system
  const labelableElements = ['a', 'button', 'section', 'article', 'nav', 'form'];
  
  labelableElements.forEach(selector => {
    document.querySelectorAll(`${selector}:not([aria-label])`).forEach(element => {
      let label = '';
      const content = element.textContent.trim();
      const keyword = getRandomKeyword();

      if (selector === 'a') {
        // Use existing link handling logic
        try {
          const url = new URL(element.href, window.location.href);
          const pathSegments = url.pathname.split('/').filter(segment => segment !== '');
          
          if (pathSegments.length === 0) {
            label = `${WEBSITE_NAME} Home`;
          } else {
            const lastSegment = pathSegments[pathSegments.length - 1];
            label = /^\d+$/.test(lastSegment)
              ? (url.hostname === window.location.hostname ? `${WEBSITE_NAME} Product Details` : 'Item Details')
              : formatLabel(lastSegment);
            
            if (url.hostname === window.location.hostname) {
              label = `${WEBSITE_NAME} ${label}`;
            }
          }
        } catch(e) {
          label = `${WEBSITE_NAME} ${keyword}`;
        }
      } else {
        // Generic element handling
        label = content.length > 0 
          ? `${WEBSITE_NAME} ${content}`
          : `${WEBSITE_NAME} baby toys ${keyword}`;
      }

      element.setAttribute('aria-label', label);
    });
  });

  // 3. Special handling for empty interactive elements
  document.querySelectorAll('button:not([aria-label]), a:not([aria-label])').forEach(element => {
    if (!element.textContent.trim()) {
      const keyword = getRandomKeyword();
      element.setAttribute('aria-label', `${WEBSITE_NAME} ${keyword}`);
    }
  });

  // 4. Remove invalid ARIA roles
  const INVALID_ROLES = { 'LI': ['group'], 'SPAN': ['button'] };
  Object.entries(INVALID_ROLES).forEach(([tagName, roles]) => {
    document.querySelectorAll(`${tagName.toLowerCase()}[role]`).forEach(element => {
      if (roles.includes(element.getAttribute('role'))) {
        element.removeAttribute('role');
      }
    });
  });
});

function formatLabel(str) {
  return str.replace(/[_-]/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}